import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { Link } from "react-router-dom";

import DatePicker from "material-ui/DatePicker";

import * as moment from "moment-timezone";

let OFFSET = 0;
let LIMIT = 30;
const historyName = "ss_fraud_limit_hits";

class LimitHits extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    // SETS DEAULT TO PREVIOUS DAY
    const filterDate = new Date();
    filterDate.setDate(filterDate.getDate() - 1);
    // TO USE SET filter_date: filterDate IN STATE

    this.state = {
      data: null,
      loading: false,
      limit: LIMIT,
      offset: OFFSET,
      filter_date: this.props.savedStates[historyName]
        ? this.props.savedStates[historyName].filter_date
        : filterDate
    };

    this.loadData = this.loadData.bind(this);

    //  PAGINATION
    this.loadNext = this.loadNext.bind(this);
    this.loadPrev = this.loadPrev.bind(this);

    //  FILTERING
    this.changeDate = this.changeDate.bind(this);
  }

  componentDidMount() {
    this.loadData(
      this.props.savedStates[historyName]
        ? this.props.savedStates[historyName].filter_date
        : this.state.filter_date,
      this.props.savedStates[historyName]
        ? this.props.savedStates[historyName].offset
        : this.state.offset
    );
    this.props.setHeader({
      title: "Fraud > Limit Hits",
      description: "Total limit hits for SnapScan"
    });
  }

  loadData(getFilter: any, getOffset: any) {
    this.props.addToStates("ss_fraud_limit_hits", {
      filter_date: getFilter,
      offset: getOffset
    });
    this.setState({
      loading: true,
      data: null,
      filter_date: getFilter,
      offset: getOffset
    });
    let createdAtFrom = null;
    let createdAtTo = null;

    if (getFilter !== null) {
      const setDateFrom = moment(getFilter)
        .startOf("day")
        .tz("Africa/Johannesburg")
        .format();
      const setDateTo = moment(getFilter)
        .endOf("day")
        .tz("Africa/Johannesburg")
        .format();
      createdAtFrom = setDateFrom;
      createdAtTo = setDateTo;
    }

    this.props.data.fetchMore({
      variables: {
        from: createdAtFrom,
        to: createdAtTo,
        offset: getOffset
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({ data: fetchMoreResult.fraud, loading: false });
      }
    });
  }

  loadNext() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) + parseInt(this.state.limit, 10);
    this.loadData(this.state.filter_date, TMP_OFFSET);
  }
  loadPrev() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) - parseInt(this.state.limit, 10);
    this.loadData(this.state.filter_date, TMP_OFFSET);
  }

  changeDate(event: any, date: any) {
    this.loadData(date, 0);
  }

  render() {
    const limitHits = this.state.data ? this.state.data.payment_limit_hits : [];

    const showData = () => {
      if (limitHits.length > 0) {
        return limitHits.map((item, i) => {
          return (
            <tr key={i}>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/merchants/${item.merchant.id}/payments`}
                >
                  {" "}
                  {item.merchant.name}{" "}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={item.merchant.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td style={{ textAlign: "left" }}>
                <Link
                  className="blueLink"
                  to={`/snapscan/fraud/merchant_limit_configs/${item.merchant.merchant_limit_configuration.name}/summary`}
                >
                  {item.merchant.merchant_limit_configuration.name}
                </Link>
              </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/users/${item.device.user.external_reference}/payments`}
                >
                  {" "}
                  {item.device.user.email}{" "}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={item.device.user.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td style={{ textAlign: "right" }}>
                R{(item.payable_amount / 100).toFixed(2)}{" "}
              </td>
            </tr>
          );
        });
      }
    };

    return (
      <section id="Fraud_LimitHits" className="padded">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start"
          }}
        >
          <DatePicker
            hintText="Data of"
            onChange={this.changeDate}
            defaultDate={this.state.filter_date}
            style={{
              width: "200px",
              marginRight: "10px"
            }}
            textFieldStyle={{
              width: "200px"
            }}
          />
        </div>

        <div
          className={`loader-container ${
            this.state.loading ? "shown" : "hidden"
          }`}
        >
          <i className={`fa fa-spinner fa-spin fa-3x fa-fw`} />
        </div>

        <div
          id="setHeight"
          style={{ height: "calc(100% - 70px)", overflow: "auto" }}
        >
          <table
            style={{
              width: "100%"
            }}
            className={`BOTable`}
            cellPadding={0}
            cellSpacing={0}
          >
            <thead>
              <tr>
                <th>Merchant</th>
                <th>Limit Category</th>
                <th>User</th>
                <th style={{ textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody className={`${this.state.loading ? "hidden" : "shown"} `}>
              {showData()}
            </tbody>
          </table>
        </div>

        <button
          className={
            this.state.offset === 0 || this.state.loading ? "hidden" : ""
          }
          style={{ margin: "5px", padding: "4px" }}
          onClick={this.loadPrev}
        >
          <i className="fa fa-chevron-left" />
        </button>
        <button
          style={{ margin: "5px", padding: "4px" }}
          className={
            limitHits.length < 30 || this.state.loading ? "hidden" : ""
          }
          onClick={this.loadNext}
        >
          <i className="fa fa-chevron-right" />
        </button>
      </section>
    );
  }
}

const limitList = gql`
  query limitList($from: String, $to: String, $offset: Int, $limit: Int) {
    fraud {
      payment_limit_hits(from: $from, to: $to, offset: $offset, limit: $limit) {
        payment_token
        reference
        payable_amount
        merchant {
          name
          id
          snapmin_url
          merchant_limit_configuration {
            name
          }
        }
        device {
          user {
            email
            external_reference
            dashboard_url
            snapmin_url
          }
        }
      }
    }
  }
`;

const limitHitsWithGraphql = graphql(limitList, {
  options(props: any) {
    return {
      variables: {
        from: null,
        to: null,
        offset: OFFSET,
        limit: LIMIT
      }
    };
  }
})(LimitHits);
export default limitHitsWithGraphql;
